// extracted by mini-css-extract-plugin
module.exports = {"container":"ButtonB_container__3Xwcw","title":"ButtonB_title__1p8Sf","rightIcon":"ButtonB_rightIcon__3ZW2r","leftIcon":"ButtonB_leftIcon__MyOrR"};